module.exports = __webpack_public_path__ + "static/media/aFichier 8.245e87e2.svg";